import script from "./RegisterAnonymousAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterAnonymousAccount.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__